import { DateRangeMapper } from "../DateRangeMapper";
export const isDifferentResponse = (request, response) => {
    if (!response.events || !response.events.length) {
        return false;
    }
    if (request.eventTags && request.eventTags.length && response.events[0].tags) {
        return response.events[0].tags.indexOf(request.eventTags[0]) === -1;
    }
    return checkDateRangeAndSportId(request, response);
};
const isDifferentDateRange = (request, response) => {
    if (request.dateRange) {
        return response.events && response.events.every(ev => {
            const date = new Date(ev.startEventDate ? ev.startEventDate : 0);
            const to = request.dateRange.from ? DateRangeMapper[request.dateRange.timeRange](request.dateRange.from) : "";
            return date < request.dateRange.from || date > to;
        });
    }
    return false;
};
const checkDateRangeAndSportId = (request, response) => {
    let dateRangeCheck = isDifferentDateRange(request, response);
    return dateRangeCheck || request.ids.indexOf(response.events && response.events[0].sportId) === -1;
};
//# sourceMappingURL=isDifferentResponse.js.map